import React from "react";
import { Container, Row, Col } from "shards-react";
import ViewProjectsSuperAdmin from "../components/project/ViewProjectsSuperAdmin";
import { toast } from "react-toastify";

class ViewProjectsPageSuperAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  //this is for showing notification
  notify(type, message) {
    toast(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      type: type,
    });
  }

  render() {
    return (
      <Container fluid className="main-content-container px-4">
        <Row className="py-3">
          <Col lg="12">
            <ViewProjectsSuperAdmin notify={this.notify} />
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ViewProjectsPageSuperAdmin;
